import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/SafeDrivingSummaryGraph/.eu';

export interface SafeDrivingSummaryGraphProps {
  score: number;
  scoreDiff: number;
}

export default function SafeDrivingSummaryGraph({score, scoreDiff}: SafeDrivingSummaryGraphProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu
            score={score}
            scoreDiff={scoreDiff}
          />
        </Environment.Kia>
      </Environment.Eu>
    </>
  );
}
